import '../scss/main.scss';

const rebuildHeader = ( wrapper ) => {
    const width = window.innerWidth;
    
    // create element for mobile search
    const search = document.createElement('div');
    search.id = 'mobile-search';

    // get search form
    const form = wrapper.querySelector('.elementor-widget-search-form');
    if( form ) search.innerHTML = form.innerHTML;

    // add search to wrapper
    wrapper.appendChild( search );
}

document.addEventListener('DOMContentLoaded', () => {

    const header = document.getElementById('custom-menu');

    if( header ) {
        const inner = header.querySelector('.elementor-container > .elementor-row');
        rebuildHeader( inner );

        /* window.addEventListener('resize', () => {
            rebuildHeader( inner );
        }) */
    }

});